export class setToken {
  static readonly type = "[app state] set token";

  constructor(public payload: any) {}
}

export class setLoginId {
  static readonly type = "[app state] set login";

  constructor(public payload: any) {}
}
export class setCrmOppurtunityId {
  static readonly type = "[app state] set oppurtunity";

  constructor(public payload: any) {}
}

export class setAllDetails {
  static readonly type = "[app state] set all details";

  constructor(public payload: any) {}
}

export class setShow {
  static readonly type = "[app state] show";

  constructor(public payload: any) {}
}

export class setIsSmallDevice {
  static readonly type = "[app state] set all details";

  constructor(public payload: any) {}
}

export class setErrorMsg {
  static readonly type = "[app state] set error msg";

  constructor(public payload: any) {}
}

export class setHideTimeline {
  static readonly type = "[app state] set timeline";

  constructor(public payload: any) {}
}

export class setShowLoader {
  static readonly type = "[app state] set loader";
  constructor (public payload: any){
    
  }
}

export class setSharedWithFinancer {
  static readonly type = "[app state] set share with financer";
  constructor(public payload:any){

  }
}
export class setRedirectionCheck {
  static readonly type = "[app state] set redirection of component";
  constructor(public payload: any) {
  }
}

export class setKycFetched {
  static readonly type = "[app state] set kyc fetched";
  constructor(public payload:any){
    
  }
}
export class setDraft {
  static readonly type = "[app state] set draft";
  constructor(public payload:any){
    
  }
}
export class setLost {
  static readonly type = "[app state] set lost";
  constructor(public payload:any){
    
  }
}

export class setFinancer {
  static readonly type = "[app state] set financer";
  constructor (public payload: any){
    
  }
}

export class setFinancers{
  static readonly type = "[app state] set financers";
  constructor (public payload: any){
    
  }
}

export class setRecommendedOffers{
  static readonly type = "[app state] set bank recommended Offers";
  constructor (public payload: any){
    
  }
}

export class setOtherOffers{
  static readonly type = "[app state] set bank other Offers";
  constructor (public payload: any){
    
  }
}

export class setMoreOffers{
  static readonly type = "[app state] set More Offers";
  constructor (public payload: any){
    
  }
}
export class setErrorStatus{
  static readonly type = "[app state] set error status";
  constructor (public payload: any){
    
  }
}

export class setDisplayCounter{
  static readonly type = "[app state] set counter";
  constructor (public payload: any){
    
  }
}

export class setHeaderTitle {
  static readonly type = "[app state] set header title";
  constructor(public payload: any) {
  }
}
